module.exports = __webpack_public_path__ + "media/images/pic/courses/5-fafbd7ae94e8f3c4a505f3a2fbb562e9.jpeg";